module.exports = __webpack_public_path__ + "img/defaultProfileImage.32d79a9b.png";